import React from 'react';
import { Card } from './ui/Card';
import { Eye, Filter } from 'lucide-react';
import { AnimatedNumber } from './AnimatedNumber';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface WorkersData {
  present: number;
  safetyOrientation: number;
  oshaAct: number;
  mandatoryDocuments: number;
}
interface WorkersCardProps {
  data: WorkersData;
  isFiltered?: boolean;
}
export function WorkersCard({
  data,
  isFiltered
}: WorkersCardProps) {
  return <Card className="h-full flex flex-col" data-id="element-4000" data-mp="29w46sfv6b3b4">
      <div className="flex justify-between items-start mb-4" data-id="element-4001" data-mp="29wxaf7yu5cp1">
        <div className="flex items-center gap-2" data-id="element-4002" data-mp="2evgypf0wj0kk">
          <h3 className="font-bold text-gray-900 text-sm" data-id="element-4003" data-mp="2etxejdc4k5di">Workers</h3>
          {isFiltered && <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="flex items-center gap-1 bg-amber-100 text-amber-700 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full" data-id="element-4004" data-mp="2iy56rkhsk3gh">
              <Filter size={10} data-id="element-4005" data-mp="3aaml9vlk6a9n" />
              Filtered
            </motion.div>}
        </div>
        <Link to="/workers" className="flex items-center gap-1.5 text-xs font-medium text-gray-600 border border-gray-200 rounded px-2.5 py-1 hover:bg-gray-50 transition-colors" data-id="element-4006" data-mp="358nhwlptjdcp">
          <Eye size={14} data-id="element-4007" data-mp="2wav1fe8d1znq" />
          View all
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center mb-6" data-id="element-4008" data-mp="2rhsh7wph42k7">
        <div className="relative w-40 h-40" data-id="element-4009" data-mp="2mjh67infzm0e">
          {/* Donut Chart Placeholder */}
          <svg viewBox="0 0 100 100" className="transform -rotate-90" data-id="element-4010" data-mp="2hkntvtjw611t">
            <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" strokeWidth="12" data-id="element-4011" data-mp="2hmh0j8ui8l9t" />
            <circle cx="50" cy="50" r="40" fill="none" stroke="#ef4444" strokeWidth="12" strokeDasharray="251.2" strokeDashoffset="50" data-id="element-4012" data-mp="28khhkazxj748" />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-4013" data-mp="1oz7kkhht8od3">
            <AnimatedNumber value={data.present} className="text-4xl font-bold text-gray-900" data-id="element-4014" data-mp="1twh5pky62dv4" />
            <span className="text-xs text-gray-500" data-id="element-4015" data-mp="2hnd5b48v6dcx">Present</span>
          </div>
        </div>
      </div>

      <div className="space-y-2 pt-4 border-t border-gray-200" data-id="element-4016" data-mp="2ml4uvrm1dndy">
        <div className="flex items-center justify-between text-sm" data-id="element-4017" data-mp="27w0dgcn2fn6w">
          <span className="text-gray-700" data-id="element-4018" data-mp="2cvv4cg6uccry">JH - Safety orientation</span>
          <AnimatedNumber value={data.safetyOrientation} className="font-semibold" data-id="element-4019" data-mp="2cu1w4wgkxkhu" />
        </div>
        <div className="flex items-center justify-between text-sm" data-id="element-4020" data-mp="35c5vek2t1qzm">
          <span className="text-gray-700" data-id="element-4021" data-mp="35eiljkipv7nr">W - OSHA / ACT</span>
          <AnimatedNumber value={data.oshaAct} className="font-semibold" data-id="element-4022" data-mp="tw5mxep40zq2" />
        </div>
        <div className="flex items-center justify-between text-sm" data-id="element-4023" data-mp="oz5cysp53cto">
          <span className="text-gray-700" data-id="element-4024" data-mp="12pqy6o22fyuq">217 - Mandatory documents</span>
          <AnimatedNumber value={data.mandatoryDocuments} className="font-semibold" data-id="element-4025" data-mp="12rv1p4w1yvuh" />
        </div>
      </div>
    </Card>;
}